import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const OpenPracticeWizardButton = () => {
    const dispatch = useDispatch();
    // bool to open the practice workflow wizard modal
    const isPracticeWorkflowModalOpen = useSelector(state => state.toggle.isPracticeWorkflowModalOpen);

    const buttonTitle = 'Create a new practice';

    const buttonClasses = 'rounded-circle text-primary bg-light';

    const buttonHandler = () => dispatch(actions.toggle.togglePracticeWorkflowModalOpen(!isPracticeWorkflowModalOpen));

    const icon = useMemo(() => <FontAwesomeIcon icon={faPlus} />, []);

    return (
        <Button title={buttonTitle} className={buttonClasses} onClick={buttonHandler}>
            {icon}
        </Button>
    );
};

export default React.memo(OpenPracticeWizardButton);
